__turbopack_context__.v({
  "isHoverOrScroll": "index-module-scss-module__Dwlb0G__isHoverOrScroll",
  "scrollbar": "index-module-scss-module__Dwlb0G__scrollbar",
  "scrollbarH": "index-module-scss-module__Dwlb0G__scrollbarH",
  "thumb": "index-module-scss-module__Dwlb0G__thumb",
  "thumbH": "index-module-scss-module__Dwlb0G__thumbH",
  "thumbV": "index-module-scss-module__Dwlb0G__thumbV",
  "viewport": "index-module-scss-module__Dwlb0G__viewport",
});
